module.exports = __webpack_public_path__ + "static/media/009.59fb38c5.jpg";